export const ADD_USER = "ADD_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const UPDATE_SEARCHES_LEFT_FOR_USER = "UPDATE_SEARCHES_LEFT_FOR_USER";
export const UPDATE_USER_BOT_INFO = "UPDATE_USER_BOT_INFO";
export const UPDATE_USER_BOT_ID_INFO = "UPDATE_USER_BOT_ID_INFO";
export const UPDATE_USER_CHAT_ID_INFO = "UPDATE_USER_CHAT_ID_INFO";
